import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
} from '@mui/material';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import ErrorGeral from './ErrorGeral';

class ErrorBoundary extends React.Component {
  state = { hasError: false, errorMessage: '' };

  static getDerivedStateFromError(error) {
    // Atualiza o state para que a próxima renderização mostre a UI alternativa.
    return {
      hasError: true,
      errorMessage: error.message,
    };
  }

  componentDidCatch(error, errorInfo) {
    // Você também pode registrar o erro em um serviço de relatórios de erro

  }

  render() {
    if (this.state.hasError) {
      // Você pode renderizar qualquer UI alternativa

      return <ErrorGeral />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
